// Conteúdo estático por categoria usado na pré-visualização/impressão da carta no Front-End
// (seção 9/10 do "Prompt Mestre V3.0"). Isto é puramente apresentacional — o texto que o
// navegador imprime/"salva como PDF" localmente — e não tem relação com os templates reais
// (CircularizacaoTemplate) usados pelo Back-End para gerar e enviar o documento oficial por
// e-mail. Antes vivia em mocks/mockCircularizacaoService.ts; extraído para cá quando o mock foi
// substituído pelo serviço real (CircularizacaoService.ts), já que não é dado de backend.
import { CATEGORIAS_CIRCULARIZACAO, CategoriaCircularizacao } from '../interfaces/ICircularizacao';

// Seção 9 — "Cada carta deverá contemplar... Informações específicas." Um template por categoria.
const ITENS_SOLICITADOS_POR_CATEGORIA: Record<CategoriaCircularizacao, string[]> = {
  FORNECEDORES: [
    'Saldo da conta corrente mantida com a empresa auditada na data-base.',
    'Títulos em aberto (duplicatas, notas fiscais, boletos) e respectivos vencimentos.',
    'Eventuais garantias, avais ou fianças prestadas em nome da empresa auditada.',
  ],
  BANCOS: [
    'Saldo de todas as contas correntes, de poupança e aplicações financeiras na data-base.',
    'Empréstimos e financiamentos vigentes — valor contratado, taxa, garantias e parcelas em aberto.',
    'Limites de crédito, avais e garantias concedidos à empresa auditada.',
    'Outras operações financeiras ou compromissos relevantes mantidos na data-base.',
  ],
  JURIDICO: [
    'Processos judiciais e administrativos em andamento envolvendo a empresa auditada.',
    'Avaliação de risco (provável, possível ou remoto) de cada contingência em curso.',
    'Valores estimados de eventuais perdas ou ganhos relacionados aos processos.',
    'Honorários advocatícios e demais despesas jurídicas pendentes de pagamento.',
  ],
  CLIENTES: [
    'Saldo de contas a receber mantido com a empresa auditada na data-base.',
    'Títulos em aberto (duplicatas, notas fiscais) e respectivos vencimentos.',
    'Eventuais disputas, glosas ou divergências sobre valores faturados.',
  ],
  PARTES_RELACIONADAS: [
    'Saldos de contas a receber/a pagar entre a empresa auditada e a contraparte.',
    'Contratos de mútuo, empréstimo ou financiamento vigentes — valor, taxa e prazo.',
    'Garantias, avais ou fianças prestadas ou recebidas entre as partes.',
    'Outras operações comerciais ou financeiras relevantes no período em auditoria.',
  ],
};

export const gerarItensSolicitados = (categoria: CategoriaCircularizacao): string[] =>
  ITENS_SOLICITADOS_POR_CATEGORIA[categoria];

export const obterLabelCategoria = (categoria: CategoriaCircularizacao): string =>
  CATEGORIAS_CIRCULARIZACAO.find((c) => c.value === categoria)?.label ?? categoria;
